import { NodeEnvTypes } from '../../types/generalTypes';

export const loggerService = (log: string) => {
	const environment = window._env_.NODE_ENV;
	if (environment !== NodeEnvTypes.PRODUCTION && environment !== NodeEnvTypes.DEV) {
		console.log(log);
	}
};
